import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { categories } from 'src/app/constants/categories';
import { Category } from '../../../models/categories-model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-categories-section',
  templateUrl: './categories-section.component.html',
  styleUrls: ['./categories-section.component.scss'],
})
export class CategoriesSectionComponent implements OnInit, OnDestroy {
  allCategories!: Category[];
  slicedCategories!: Category[];
  initialListCount = 6;
  categoriesConfig = categories;
  loadingCtgrs = Array.from({ length: 4 });

  private categoryCardSubs!: Subscription;

  @Input() isLoading!: boolean;
  @Input() set categories(items: Category[]) {
    this.allCategories = items;
    this.slicedCategories = items?.slice(0, this.initialListCount);
  }

  @ViewChild('categorySection') private categorySectionRef!: ElementRef;
  @ViewChildren('categoryCard')
  private categoryCardsRef!: QueryList<HTMLDivElement>;

  constructor(
    private route: Router
  ) {}

  ngOnInit() {}

  get isShowAllCatgrsBtn() {
    return !this.isLoading && this.allCategories.length > this.initialListCount;
  }

  private scrollCategorySection() {
    (<HTMLElement>this.categorySectionRef?.nativeElement).scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'end',
    });
  }

  onExploreAllCtgrs() {
    // When all categories are already shown in UI
    if (this.slicedCategories.length === this.allCategories.length) {
      this.scrollCategorySection();
      return;
    }

    // If all categories are not shown in UI
    this.slicedCategories = this.allCategories;
    // Scroll to end when UI gets updated
    this.categoryCardSubs = this.categoryCardsRef.changes.subscribe(() => {
      this.scrollCategorySection();
      this.categoryCardSubs.unsubscribe();
    });
  }

  ngOnDestroy() {
    this.categoryCardSubs?.unsubscribe();
  }

  navigateToService(category:any){
    const queryParams = {category: category.categoryId};
      this.route.navigate(['/services'], {queryParams});
  }
}
